module.exports = __webpack_public_path__ + "static/media/top01.37ce8880.svg";